<template>
  <Cascader
    filterable
    :options="list"
    v-model="cascaderSelected"
    @change="cascaderOnChange"
    :transfer="true"
    :disabled="disabled"
    clearable
    style="width:100%"
    :size="size"
  ></Cascader>
</template>
<script>
import { hasOneOf } from "@/libs/tools";

var LTT = require("list-to-tree");
import { getTypeTreeData } from "@/api/type";

import { Cascader } from "element-ui";

export default {
  name: "locTypeCascader",
  components: {
    Cascader
  },
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    locTypekey: {
      type: String,
      default: () => ""
    },
    guid: {
      type: String,
      default: () => ""
    },
    getParentType: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: () => "medium"
    }
  },
  data() {
    return {
      list: [],
      listFlat: [],
      cascaderSelected: [],
      modalShow: false,
      selectedTypeId: 0,
      locTypeModel: {},
      editMode: false,
      postedId: 0,

      fields: [],
      fieldsModel: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    selectSelected(id){
      this.cascaderSelected = [];
      // console.log("selectSelected", id, this.listFlat);
          this.cascaderModelRecursive(
            this.listFlat,
            id
          );
          this.cascaderSelected = this.cascaderSelected.reverse();
      //  console.log("selectSelected", this.cascaderSelected);
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    init() {
      getTypeTreeData({
        params: {
          key: this.locTypekey,
          getParentType: this.getParentType
        },
        store: this.$store
      }).then(res => {
        let dataTypes = res.data.types;
        this.listFlat = dataTypes;
        var ltt = new LTT(dataTypes, {
          key_id: "id",
          key_parent: "parentId",
          key_child: "children"
        });
        this.list = ltt.GetTree();
        //console.log(this.list)
        this.cascaderSelected = [];
        if (this.id > 0 || this.postedId > 0) {
          this.cascaderModelRecursive(
            this.listFlat,
            this.postedId > 0 ? this.postedId : this.id
          );
          this.cascaderSelected = this.cascaderSelected.reverse();
        } else this.cascaderSelected = [];

        this.$emit("on-data-fired");

      });
    },
    cascaderModelRecursive(data, cid) {
      // console.log("cascaderModelRecursive", data, cid);
      this.cascaderSelected.push(cid);
      let pid = data.filter(d => d.id == cid)[0].parentId;
      if (pid > 0) {
        // console.log("pid", pid);
        this.cascaderModelRecursive(data, pid);
      }
    },
    cascaderOnChange(value) {
      // console.log("isChanged")
      let _id =
        value[value.length - 1] != undefined ? value[value.length - 1] : null;

      //console.log(_id);

      // getFields({ locTypeId: _id }).then(res => {
      //   this.fields= res.data.fields;
      // });

      this.$emit("loctype-selected", { id: _id, guid: this.guid });
      this.$emit("on-change", _id);
    }
  }
};
</script>
